
<mat-expansion-panel expanded="false">
  <mat-expansion-panel-header>Filtrer les demandes / réponses sur les champs paramétrés du formulaire</mat-expansion-panel-header>
  <mat-card>
    <mat-card-content>
      <div style="padding-bottom: 10px;">
        <app-filter-custom-enabled *ngIf="fieldsEnabled && fieldsEnabled.length > 0"
                                   [fields]="fieldsEnabled"
                                   (onFilterRaz)="onFilterRaz($event)"></app-filter-custom-enabled>
        <mat-divider></mat-divider>
      </div>
      <div>
        <mat-form-field *ngIf="fields">
          <mat-select placeholder="Colonne à filtrer"
                      (selectionChange)="onSelectField($event)" data-cy="select-filter-selection-filter-column">
            <mat-option *ngFor="let field of fields"
                        [value]="field" [attr.data-cy]="'option-filter-selection-'+field.id">{{field.options_obj.label}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div *ngIf="selectedField">
        <app-filter-type-value [field]="selectedField"
                               (valueChanged)="onValueChanged($event)"></app-filter-type-value>
      </div>
      <div style="padding-top: 10px;">
        <button color="accent" class="mat-button mat-small" mat-raised-button
                [disabled]="isDisabled()"
                (click)="onAddFilter()" matTooltip="Filtrer">Ajouter ce filtre</button>&nbsp;
      </div>
    </mat-card-content>
  </mat-card>
</mat-expansion-panel>
